// EXEMPLO SINTETICO DO ARQUIVO MENSAL DA ASSALCE (#165). Nao contem dado real:
// matriculas e valores sao inventados. O arquivo real traz matricula e valor
// por pessoa e NAO entra no repositorio.
//
// Exercita todo valor que `assalce-entrada` declara na matriz: largura fixa sem
// cabecalho, virgula decimal com zeros a esquerda, matricula com zeros, a
// referencia `MM/AA a MM/AA`, a competencia no nome, CRLF e linhas vazias no
// fim. E os descartes: valor zero e uma linha torta.
export const ASSALCE_EXEMPLO_COMPETENCIA = "202609";
export const ASSALCE_EXEMPLO_NOME = `ASS${ASSALCE_EXEMPLO_COMPETENCIA}.TXT`;
export const ASSALCE_EXEMPLO_LINHAS = [
    // Planos (recorrentes): matricula e folha com zeros.
    "001476 03 641 0006604,10              ",
    "002001 03 667 0000980,55              ",
    "000055 12 640 0000045,90              ",
    // Avulsas: convenio e ajuste de diferenca.
    "001476 03 911 0000150,00              ",
    "003010 15 913 0001250,37              ",
    // Averbacao com prazo: a referencia diz de quando a quando.
    "002060 03 807 0000350,00 03/26 a 02/31",
    "004120 09 779 0000210,00 07/26 a 12/26",
    // Valor zero: descartado (a ALECE encerra por omissao).
    "003011 03 779 0000000,00              ",
    // Linha torta (o valor veio com 9 posicoes): descartada com motivo, o resto e' lido.
    "004002 03 641 000100,00",
    // Linha sem os espacos do fim (referencia em branco cortada): lida normalmente.
    "004003 03 641 0000100,00",
];
export const ASSALCE_EXEMPLO_TEXTO = `${ASSALCE_EXEMPLO_LINHAS.join("\r\n")}\r\n\r\n\r\n`;
//# sourceMappingURL=assalce-exemplo.js.map